<template>
  <div class="grid grid-cols-[minmax(30px,150px)_1fr] gap-4 items-center mt-8">
    <FormLabel label="Type">
      <FormKit
        :options="LIGHTBASE_TYPE_OPTIONS"
        name="lightBaseType"
        placeholder="Choose a type"
        type="select"
      />
    </FormLabel>
    <FormLabel label="QTY">
      <FormKit name="lightBaseQty" type="text" />
    </FormLabel>
    <FormLabel label="Cost">
      <FormKit v-model="basePrice" name="lightBasePrice" type="text" />
    </FormLabel>
    <DiscountField
      :values="values"
      checkboxName="lightBaseDiscount"
      priceName="lightBaseDiscountPrice"
      priceTypeName="lightBaseDiscountType"
    />
  </div>
</template>
<script setup>
import DiscountField from "@/components/Order/DiscountField/DiscountField.vue";
import { LIGHTBASE_TYPE_OPTIONS } from "@/consts/newOrderFormInputs";
import { computed, toRefs } from "vue";
import { LIGHTBASE_PRICES } from "@/consts/orderInitialValues";
import FormLabel from "../../../UI/Form/FormLabel.vue";

const props = defineProps({
  values: {
    type: Object,
    default: () => ({}),
  },
});

const { values } = toRefs(props);

const basePrice = computed(() => LIGHTBASE_PRICES[values.value.lightBaseType] || null);
</script>
